'use strict';

module.exports = Object.getOwnPropertyDescriptor;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/var/getOwnPropertyDescriptor.js
// module id = 311
// module chunks = 0